import { render, staticRenderFns } from "./CondominiumProfile.vue?vue&type=template&id=46280b46&scoped=true&"
import script from "./CondominiumProfile.vue?vue&type=script&lang=ts&"
export * from "./CondominiumProfile.vue?vue&type=script&lang=ts&"
import style0 from "./CondominiumProfile.vue?vue&type=style&index=0&id=46280b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46280b46",
  null
  
)

export default component.exports